export const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
  btnStatus: {
    width: "6rem",
    minWidth: 80,
    fontSize: "0.675rem",
  },
  tableCellEdit: {
    borderBottom: "none",
  },
  // modify
  tableRowHeight: {
    height: 0,
  },
  customColumn: {
    paddingTop: "0.8rem",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "0.8rem",
  },
  updatedAtRow: {
    marginTop: "0.2rem",
    fontSize: "0.75rem",
    color: "#546e7a",
  },
  tableCellInCollapes: {
    borderBottom: "none",
  },
});
export const textFieldStyles = (theme) => ({
  actionForm: {
    // marginTop: '1rem'
  },
  label: {
    fontWeight: "500",
  },
  badge: {
    top: 1,
    width: "1.6rem",
    height: "1.6rem",
    borderRadius: "50%",
    // The border color match the background color.
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
    }`,
  },
  actionLine: {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
  },
  chip: {
    margin: theme.spacing(1),
  },
  emotionContainer: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
  },
  emotionText: {
    marginLeft: "0.5rem",
  },
  iconEmotion: {
    width: "1.5rem",
  },
  love: {
    color: "#fa52d9",
  },
  happy: {
    color: "#28a745",
  },
  normal: {
    color: "#007bff",
  },
  sad: {
    color: "#ffc107",
  },
  angry: {
    color: "#dc3545",
  },
  breakLine: {
    width: "100%",
  },
});
